import React from "react";
import { Box } from "@chakra-ui/react";
import { DecorativeBackgroundImage, FillImage } from "components/images";
import { MediaAccordion } from "ui/accordion";
import { TextTitle } from "ui/text";
import { horizontalContainerPadding } from "ui/container";
import firstBgImage from "../../../../public/assets/home/accordion-1-bg.png";
import secondImage from "../../../../public/assets/home/accordion-2.png";
import thirdImage from "../../../../public/assets/home/accordion-3.png";
import { AidNotificationsAnimation } from "./notifications-animation";

const items = [
  {
    title: "AI decides the best content to send",
    content:
      "AI Decisioning pulls from your content library and matches messages with each customer based on their probability of taking an action.",
    media: (
      <Box boxSize="100%" bg="new.blue.300">
        <DecorativeBackgroundImage src={firstBgImage} />
        <AidNotificationsAnimation />
      </Box>
    ),
  },
  {
    title: "Set your goals and guardrails",
    content:
      "Define rules to make sure you only reach the customers you want, at frequencies and with messages that meet your brand standards.",
    media: (
      <FillImage
        src={secondImage}
        alt="Illustration of UI rule selections for timings and related outcomes. The timings rules have various items selected in regards to frequencies, days of the week, and times of day. The outcomes show two columns: names and classification. Some rows include purchase, best, and unsubscribe, worst."
      />
    ),
  },
  {
    title: "Test and learn across every customer",
    content:
      "AI Decisioning studies how customers react to every message, updates millions of predictions and surfaces insights on patterns in a dashboard.",
    media: (
      <FillImage
        src={thirdImage}
        alt="Illustration of AI Decisioning dashboard for an apparel retailer. The dashboard highlights user patterns across multiple products in relation to category affinity and click through rates."
      />
    ),
  },
];

export function AidAccordion({ isHidden }: { isHidden?: boolean }) {
  return (
    <Box
      display={isHidden ? "none" : "block"}
      as="section"
      maxW="container.section"
      mx="auto"
      px={horizontalContainerPadding}
      mb="big"
    >
      <TextTitle
        theme="dark"
        align="center"
        size="lg"
        chip={{ text: "AI Decisioning Platform" }}
        title="AI agents that give every customer the exact experience they need"
        description="Rip up your campaign calendar and turn off your A/B tests. Unleash AI agents to experiment on a 1:1 basis and quickly unlock growth in LTV and loyalty."
      />
      <MediaAccordion theme="dark" variant="dynamic" direction="right" items={items} mt={{ base: "big", md: "huge" }} />
    </Box>
  );
}
